import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[libTimeMask]'
})
export class TimeMaskDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }

  formatHoursAndMinutes(input):any {
    let len = input.length;

    switch(len) {
      case 1: {
        if(/\d/.test(input)){
          break;
        }  else {
          input = "";
        }
      } break;
      case 2: {
        if(/\d{2}/.test(input)){
          break;
        } else if(/\d\:/.test(input)) {
          input= "0"+input;
        }
      }break;
      case 3: {
        if(/\d{2}\:/.test(input)){
          break;
        }  else if(/\d{3}/.test(input)){
          input = input.substring(0,2)+":"+input.substring(2,3);
        }
      }break;
      case 4: {
        if(/\d{2}\:\d/.test(input)) {
          break;
        } else if(/\d{4}/.test(input)){
          input = input.substring(0,2)+":"+input.substring(2,4);
        } else if(/\d{2}\:\:/.test(input)) {
          input = input.substring(0,2)+":";
        }
      }
    }
    return input;
  }

  
  onInputChange(event) {
     
    let input = event;
    if(input==null){
      input = "";
    }
    
    input = input.replace(/[a-z]|[A-Z]|\*|\&|\%|\@|\#|\\|\^|\!|\_|\-|\+|\=|\\|\}\s/g,"");
    let len = input.length;

    switch(len) {
      case 1: 
      case 2: 
      case 3: 
      case 4: 
        input = this.formatHoursAndMinutes(input);
        break;
      case 5: {
        if(/\d{2}\:\d{2}/.test(input)){
          break;
        } else if(/\d{2}\:\d\:/.test(input))
        {
          input = input.substring(0,2)+":0"+input.substring(3,4)+":";
        }
      }break;
      case 6: {
        if(/\d{2}\:\d{2}\:/.test(input)){
          break;
        } else if(/\d{2}\:\d{3}/.test(input)){
          input = input.substring(0,5)+":"+input.substring(5,6);
        }
      }break;
      case 7: {
        if(/\d{2}\:\d{2}\:\d/.test(input)){
          break;
        } else if(/\d{2}\:\d{2}\:\:/.test(input)) {
          input = input.substring(0,6);
        } else if(/\d\:\:\d{4}/.test(input)) {
          input = "0"+input.substring(0,7);
        }
      }break;
      case 8: {
        if(/\d{2}\:\:\d{4}/.test(input)) {
            break;
        } else if(/\d{3}\:\d{4}/.test(input)) {
          input = input.substring(0,2) + ":" + input.substring(2,len);
        }
      }break;
    }
    this.ngControl.valueAccessor.writeValue(input);
  }
}